import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import ProtectedRoute from './components/common/ProtectedRoute';

// Pages
import Landing from './pages/Landing';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import ForgotPassword from './pages/auth/ForgotPassword';
import Dashboard from './pages/dashboard/Dashboard';
import JobsList from './pages/jobs/JobsList';
import JobDetail from './pages/jobs/JobDetail';
import JobForm from './pages/jobs/JobForm';
import CompaniesList from './pages/companies/CompaniesList';
import CompanyDetail from './pages/companies/CompanyDetail';
import Profile from './pages/profile/Profile';
import Admin from './pages/admin/Admin';

// Static pages
import { AboutPage, ContactPage, CareersPage, CareerResourcesPage, PricingPage, RecruitmentSolutionsPage, PostJobPage, NotificationsPage } from './pages/static/StaticPages';
import { PrivacyPolicyPage, TermsPage, CookiePolicyPage } from './pages/static/LegalPages';
import Settings from './pages/settings/Settings';

const App = () => (
  <Routes>
    <Route element={<Layout />}>
      {/* Public */}
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />

      {/* Jobs */}
      <Route path="/jobs" element={<JobsList />} />
      <Route path="/jobs/:id" element={<JobDetail />} />

      {/* Companies */}
      <Route path="/companies" element={<CompaniesList />} />
      <Route path="/companies/:id" element={<CompanyDetail />} />

      {/* Static / Content Pages */}
      <Route path="/about" element={<AboutPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/careers" element={<CareersPage />} />
      <Route path="/career-resources" element={<CareerResourcesPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/recruitment-solutions" element={<RecruitmentSolutionsPage />} />
      <Route path="/post-job" element={<PostJobPage />} />

      {/* Legal */}
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/cookie-policy" element={<CookiePolicyPage />} />

      {/* Protected - Any authenticated user */}
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/notifications" element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />

      {/* Protected - Recruiter/Admin only */}
      <Route path="/jobs/create" element={<ProtectedRoute roles={['recruiter', 'admin']}><JobForm /></ProtectedRoute>} />
      <Route path="/jobs/:id/edit" element={<ProtectedRoute roles={['recruiter', 'admin']}><JobForm /></ProtectedRoute>} />

      {/* Protected - Admin only */}
      <Route path="/admin" element={<ProtectedRoute roles={['admin']}><Admin /></ProtectedRoute>} />

      {/* 404 */}
      <Route path="*" element={
        <div className="static-page">
          <div className="container" style={{ textAlign: 'center', padding: '4rem 0' }}>
            <h1 style={{ fontSize: '4rem', opacity: 0.3 }}>404</h1>
            <h2>Page Not Found</h2>
            <p style={{ color: 'var(--text-muted)', marginBottom: '1.5rem' }}>The page you're looking for doesn't exist.</p>
            <a href="/" className="btn btn-primary">Go Home</a>
          </div>
        </div>
      } />
    </Route>
  </Routes>
);

export default App;
